import React from 'react'
import { Link } from 'react-router-dom'
import { motion } from 'framer-motion'
import SafeIcon from '../../common/SafeIcon'
import * as FiIcons from 'react-icons/fi'
import Card from '../ui/Card'
import Badge from '../ui/Badge'
import Button from '../ui/Button'
import RewardRequestNotifications from '../rewards/RewardRequestNotifications'

const { FiBell, FiArrowRight } = FiIcons

const RewardRequestWidget = () => {
  return (
    <Card>
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100 flex items-center gap-2">
          <SafeIcon icon={FiBell} className="text-orange-500" />
          Reward Requests
        </h3>
        <Link to="/settings">
          <Button variant="ghost" size="sm">
            View All
            <SafeIcon icon={FiArrowRight} className="text-sm" />
          </Button>
        </Link>
      </div>

      <RewardRequestNotifications maxDisplay={2} />

      <div className="mt-4 p-3 bg-blue-50 dark:bg-blue-900/20 rounded-lg">
        <p className="text-sm text-blue-700 dark:text-blue-300">
          💡 <strong>Tip:</strong> Respond to requests quickly to keep kids motivated!
        </p>
      </div>
    </Card>
  )
}

export default RewardRequestWidget